import { defineStore } from 'pinia';

import { G } from '@/_common';

import { main_stores } from './stores';
import { user_stores } from '@/_stores';

export const useStore = defineStore('Diarc', {
    state: () => (Object.assign({
        lang: 'az',
        lang_id: 1,
        currency: 'AZN',
        translations: {},
        sidebarStatus: false,
        dataTableParams: {
            page: 1,
            rows: G.rowsPerPage,
            mainFilters: {},
            filters: ''
        },
        token: "",
        api_version: Object.assign({}, user_stores.api_version),
        api: Object.assign(main_stores.api, user_stores.api),
    }, main_stores.data || {}, user_stores.data || {})),

    getters: Object.assign({
        getSidebarStatus: (state) => () => {
            if( G.getClientData("da-left-sidebar") == "true" )
                state.sidebarStatus = true;
            return state.sidebarStatus;
        },
        setSidebarStatus: (state) => (value, event) => {
            window.bootstrap.Dropdown.clearMenus(event);
            G.setClientData("da-left-sidebar", value);
            return state.sidebarStatus = value; //.find(todo => todo.id === id)
        },

        getDataTableParams: (state) => () => {
            return state.dataTableParams;
        },
        setDataTableParams: (state) => (value) => {
            if( value === undefined )
                value = {
                    page: 1,
                    rows: G.rowsPerPage,
                    mainFilters: {},
                    filters: ''
                };
            state.dataTableParams = value;
        },

        getLang: (state) => () => {
            return state.lang;
        },
        getLangId: (state) => () => {
            return state.lang_id;
        },
        getCurrency: (state) => () => {
            return state.currency;
        },
        getTranslation: (state) => () => {
            return state.translations;
        },
    }, main_stores.getters, user_stores.getters),

    actions: Object.assign({
        setLang(lang) {
            if (lang === undefined || lang == '')
                lang = 'az';
            this.lang = lang;
        },
        setLangId(lang_id) {
            if (lang_id === undefined || lang_id == '' || lang_id == 0)
                lang_id = 1;
            this.lang_id = lang;
        },
        setCurrency(currency) {
            if (currency === undefined || currency == '')
                currency = 'AZN';
            this.currency = currency;
        },
        setTranslations(tr) {
            if (tr !== undefined){
                this.translations = tr;
            }
        },
    }, main_stores.actions, user_stores.actions),
    // actions: ,
});